module.exports = __webpack_public_path__ + "img/mapbase.2d5dba0c.png";